import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const AdminNewsPage = ({ token }) => {
    const [newsArticles, setNewsArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const apiBaseUrl = import.meta.env.VITE_API_URL;

    useEffect(() => {
        const fetchNewsArticles = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${apiBaseUrl}/api/news/all`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setNewsArticles(data);
            } catch (err) {
                console.error("Error fetching news articles:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (token) {
            fetchNewsArticles();
        }
    }, [token, apiBaseUrl]);

    if (!token) {
        return <p>Please log in to manage news articles.</p>;
    }

    if (loading) {
        return <p>Loading news articles...</p>;
    }

    if (error) {
        return <p>Error loading news articles: {error}</p>;
    }

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Manage News Articles</h1>
            <div className="mb-4">
                {/* Link to a new page/modal for creating articles */}
                <Link to="/admin/news/new" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                    Add New Article
                </Link>
            </div>
            {newsArticles.length === 0 ? (
                <p>No news articles found.</p>
            ) : (
                <table className="min-w-full">
                    <thead className="bg-gray-800 text-white">
                        <tr>
                            <th className="w-1/3 text-left py-3 px-4 uppercase font-semibold text-sm">Title</th>
                            <th className="w-1/3 text-left py-3 px-4 uppercase font-semibold text-sm">Publish Date</th>
                            <th className="text-left py-3 px-4 uppercase font-semibold text-sm">Published</th>
                            <th className="text-left py-3 px-4 uppercase font-semibold text-sm">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="text-white">
                        {newsArticles.map(article => (
                            <tr key={article.id} className="border-b">
                                <td className="w-1/3 text-left py-3 px-4">{article.title}</td>
                                <td className="w-1/3 text-left py-3 px-4">{article.publish_date ? new Date(article.publish_date).toLocaleDateString() : 'N/A'}</td>
                                <td className="text-left py-3 px-4">{article.is_published ? 'Yes' : 'No'}</td>
                                <td className="text-left py-3 px-4">
                                    {/* Links to edit/delete actions */}
                                    <Link to={`/admin/news/edit/${article.id}`} className="mr-4">
                                        <button className="text-blue-500 hover:text-blue-700">
                                            Edit
                                        </button>
                                    </Link>
                                    {/* Add delete functionality here */}
                                    <button onClick={() => alert(`Delete article ${article.id}? (to be implemented)`)} className="text-red-500 hover:text-red-700">
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default AdminNewsPage;
